import React, { Component } from 'react';
// components
import Table from '../../Items/Table';
import { Button } from '@material-ui/core';
class ResellerPersonsTable extends Component {
    render() {

        const tableData = {
            title: "Personel Listesi",
            options: {
                paging: true,
                selection: true,
                grouping: true,
                filtering: true,
                columnsButton: true,
                exportButton: false,
                actionsColumnIndex: 4,
                pageSize: 10,
                pageSizeOptions: [10, 20, 50, 100, 1000]
            },
            columns: [
                this.props.person.permissions.reseller.personUpdate ? {
                    title: 'İşlem',
                    render: rowData => {
                        return (
                            <Button onClick={() => this.props.editForm(rowData)}>Güncelle</Button>
                        )
                    },
                } : {},
                { title: "Ünvanı", field: "title" },
                // { title: "İkinci Ad", field: "lastName" },
                // { title: "Soyad", field: "surname" },
                { title: "Email", field: "email" },
                { title: "Telefon", field: "mobilePhone" },
            ],
            data: this.props.resellerPersons
        };

        let tableActions = [];
        if (this.props.person.permissions.reseller.personDelete) {
            tableActions.push({
                icon: 'delete',
                tooltip: 'Sil',
                onClick: this.props.delete,
                iconProps: {
                    style: {
                        fontSize: 40,
                        color: 'red'
                    }
                }
            });
        }



        if (this.props.person.permissions.reseller.personCreate) {
            tableActions.push({
                icon: 'plus_one',
                isFreeAction: true,
                tooltip: 'Yeni Kayıt Ekle',
                onClick: this.props.addForm,
                iconProps: {
                    style: {
                        fontSize: 40,
                        color: 'green'
                    }
                }
            });
        }

        return (
            <div>
                <Table
                    tableData={tableData}
                    actions={tableActions.length > 0 ? tableActions : null} />
            </div>
        )
    }
}


export default ResellerPersonsTable;